/**
 @ngdoc service
 @name mapPermstartconfirmationTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapPermstartconfirmationTileService = function(tileDataFactory) {

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            var self = this;

            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);

            // Adding labels to column structured data
            if(rawTileData.jobCorporateURI){
                tileFactory.addFieldToColumn1(tileFactory.field.newLinkBusinessModelField('jobId', 'jobURI', 'jobCorporateURI'));
            }
            else {
                tileFactory.addFieldToColumn1(tileFactory.field.newLinkField('jobId','jobURI'));
            }
            if(tileFactory.isPrincipal()){
                tileFactory.addFieldToColumn1(tileFactory.field.newLinkJoinField('candidateFirstName', 'candidateLastName','candidateURI'));
            }else {
                tileFactory.addFieldToColumn1(tileFactory.field.newJoinField('candidateFirstName', 'candidateLastName'));
            }
            tileFactory.addFieldToColumn1(tileFactory.field.newField('jobTitle'));

            tileFactory.addFieldToColumn2(tileFactory.field.newAddressField('workingAddress'));
            if(tileFactory.isPrincipal()){
                tileFactory.addFieldToColumn2(tileFactory.field.newField('supplierOrgUnitName'));
            }


            if(tileFactory.isPrincipal()) {
                tileFactory.addFieldToColumn2(tileFactory.field.newOrganisationFieldWithLink('procurerOrgUnitName', 'procurerOrgName', 'businessURI'));
            }else{
                tileFactory.addFieldToColumn2(tileFactory.field.newOrganisationField('procurerOrgUnitName', 'procurerOrgName'));
            }

            tileFactory.addFieldToColumn3(tileFactory.field.newRatePerUnitField(
                'payRate',
                rawTileData.payType.id,
                lookupValues[rawTileData.payType.lookupKey][rawTileData.payType.id],
                true
            ));
            tileFactory.addFieldToColumn3(tileFactory.field.newRatePerUnitField(
                'benefits',
                rawTileData.payType.id,
                lookupValues[rawTileData.payType.lookupKey][rawTileData.payType.id],
                true
            ));

            tileFactory.addFieldToColumn3(tileFactory.field.newRatePerUnitField(
                'jobPackage',
                rawTileData.payType.id,
                lookupValues[rawTileData.payType.lookupKey][rawTileData.payType.id],
                true
            ));

            tileFactory.addFieldToColumn4(tileFactory.field.newField('startDate', 'date'));
            tileFactory.addFieldToColumn4(tileFactory.field.newField('comments'));
            if(tileFactory.isPrincipal() && rawTileData.nonAuthorisedPlacement==true ) {
                tileFactory.addFieldToColumn4(tileFactory.field.newFieldBooleanYesOrNo('nonAuthorisedPlacement'));
            }

            if( tileFactory.isPrincipal()) {
                tileFactory.addFieldToColumn4(tileFactory.field.newField('orderingManager'));
                tileFactory.addFieldToColumn4(tileFactory.field.newLinkJoinField('hiringManagerFirstName', 'hiringManagerLastName', 'hiringManagerURI'));

            }

            // 533: "Awaiting Authorisation"
            // 534: "Awaiting Resubmission"
            // 535: "Awaiting Repost (financials)"
            // 536: "Rejected"
            // 537: "Authorised"
            // 4826: "Cancelled"
            // 4827: "Awaiting Repost (allocation)"
            // 4953: "In Review"
            // 4954: "Processing"
            // 5161: "Awaiting Overtime Authorisation"
            // 5276: "Reversed"
            // 5397: "Awaiting Repost Authorisation (allocation)"
            // 5398: "Awaiting Repost Authorisation (financials)"
            tileFactory.addStatus(tileFactory.status.newStatus('permStartStatus',
                // Positives
                [
                    tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AUTHORISED
                ],
                // Negatives
                [
                    tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_CANCELLED,
                    tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_REJECTED
                ],
                // Warnings
                [
                    tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AWAITING_AUTHORISATION,
                    tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AWAITING_RESUBMISSION,
                    tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AWAITING_REPOST_FINANCIALS,
                    tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AWAITING_REPOST_ALLOCATION,
                    tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AWAITING_OVERTIME_AUTHORISATION,
                    tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AWAITING_REPOST_AUTHORISATION_FINANCIALS
                ]
            ));

            return tileFactory.tileData;
        };

        return {
            map : map
        };
    };

    mapPermstartconfirmationTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapPermstartconfirmationTileService', mapPermstartconfirmationTileService);

}());